<script lang="ts" setup>
import { cn } from '@/lib/utils';
import { CalendarGridRow, useForwardProps, type CalendarGridRowProps } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<CalendarGridRowProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { ...delegated } = props;
  delete delegated.class;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <CalendarGridRow :class="cn('flex', props.class)" v-bind="forwardedProps">
    <slot />
  </CalendarGridRow>
</template>
